import React from 'react';
import { Facebook, Link2 } from 'lucide-react';
import { toast } from 'sonner';
import { API } from '../lib/api';

const btn = 'inline-flex items-center gap-2 font-sans-ah text-[12px] tracking-wide-ah px-4 py-2.5 rounded-sm transition-colors';

export default function ShareEvent({ eventId }) {
  const shareUrl = `${API}/share/events/${eventId}`;
  const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
  const copy = async () => {
    await navigator.clipboard.writeText(`${window.location.origin}/events/${eventId}`);
    toast.success('Event link copied');
  };
  return (
    <div className="mb-10" data-testid="event-share">
      <p className="font-sans-ah text-[12px] tracking-wide-ah text-[#999] uppercase mb-3">Spread the word</p>
      <div className="flex flex-wrap gap-2">
        <a href={fbUrl} target="_blank" rel="noopener noreferrer" data-testid="share-facebook-btn"
          className={`${btn} bg-[#1877f2] text-white hover:bg-[#145dbf]`}>
          <Facebook size={15} /> SHARE ON FACEBOOK
        </a>
        <button type="button" onClick={copy} data-testid="share-copy-link-btn"
          className={`${btn} border border-neutral-300 text-[#555] hover:border-[#4a9cd4] hover:text-[#4a9cd4]`}>
          <Link2 size={15} /> COPY LINK
        </button>
      </div>
    </div>
  );
}
